// ── VARIANT DATA (URLs injected by Liquid in index.liquid) ──
// V is defined inline in the template
var IDX = {p1:0,p2:0,p3:0,p4:0,p5:0};
var TIMERS = {};
var CROSS = {};

function showImg(pid, i) {
  var imgs = V[pid];
  if (!imgs) return;
  IDX[pid] = i;
  var front = document.getElementById(pid + '-img');
  var back  = document.getElementById(pid + '-img-back');
  if (!front) return;

  if (!back) {
    front.src = imgs[i];
    return;
  }

  if (CROSS[pid]) return;
  CROSS[pid] = true;

  back.src = imgs[i];
  back.style.zIndex = '3';
  void back.offsetWidth;
  back.style.opacity = '1';

  setTimeout(function() {
    front.src = imgs[i];
    front.style.opacity = '1';
    back.style.opacity = '0';
    back.style.zIndex = '1';
    CROSS[pid] = false;
  }, 680);

  var card = front.closest('.product-card');
  if (card) {
    card.querySelectorAll('.color-dot').forEach(function(d, j) {
      d.style.outline = (j === i) ? '2px solid #2db5a3' : 'none';
      d.style.outlineOffset = '2px';
    });
  }
}

function dot(pid, i) { stopAuto(pid); showImg(pid, i); }

function startAuto(pid) {
  if (!V[pid] || V[pid].length < 2) return;
  stopAuto(pid);
  TIMERS[pid] = setInterval(function(){
    showImg(pid, (IDX[pid] + 1) % V[pid].length);
  }, 2000);
}

function stopAuto(pid) {
  if (TIMERS[pid]) { clearInterval(TIMERS[pid]); TIMERS[pid] = null; }
}

window.addEventListener('load', function(){
  ['p1','p2','p3','p4'].forEach(function(pid){ startAuto(pid); });

  document.querySelectorAll('.color-dot').forEach(function(dotEl){
    var card = dotEl.closest('.product-card');
    if (!card) return;
    var pid = null;
    Object.keys(V).forEach(function(p){
      var img = document.getElementById(p + '-img');
      if (img && img.closest('.product-card') === card) pid = p;
    });
    if (!pid) return;
    var dots = Array.from(card.querySelectorAll('.color-dot'));
    var idx = dots.indexOf(dotEl);
    dotEl.addEventListener('mouseenter', function(){ stopAuto(pid); showImg(pid, idx); });
    dotEl.addEventListener('mouseleave', function(){ startAuto(pid); });
  });
});

// ── COUNTDOWN ──────────────────────────────────────────────
function startTimer(){
  var t = 7*3600+38*60+52;
  setInterval(function(){
    if(t<=0) return; t--;
    var h=Math.floor(t/3600), m=Math.floor((t%3600)/60), s=t%60;
    var f=function(v){ return String(v).padStart(2,'0'); };
    ['h-h','h-m','h-s'].forEach(function(id,i){
      var el=document.getElementById(id); if(el) el.textContent=f([h,m,s][i]);
    });
    ['b-h','b-m','b-s'].forEach(function(id,i){
      var el=document.getElementById(id); if(el) el.textContent=f([h,m,s][i]);
    });
  },1000);
}
startTimer();

// ── FILTER ─────────────────────────────────────────────────
function filterProducts(cat,btn){
  document.querySelectorAll('.filter-btn').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');
  document.querySelectorAll('.product-card').forEach(function(c){
    c.style.display = (cat==='all' || c.dataset.cat===cat) ? '' : 'none';
  });
}

// ── FAQ ────────────────────────────────────────────────────
function toggleFaq(el){ el.closest('.faq-item').classList.toggle('open'); }

// ── MODAL ──────────────────────────────────────────────────
function openModal(pid){
  var p = PD[pid];
  if (!p) return;
  var imgs = V[pid] || [];

  var imgEl = document.getElementById('modal-img-area');
  imgEl.innerHTML = imgs.length
    ? '<img id="modal-main-img" src="' + imgs[0] + '" style="max-width:100%;max-height:340px;object-fit:contain;"/>'
    : '<div style="font-size:60px;text-align:center">🌬️</div>';

  var colorDiv = document.createElement('div');
  colorDiv.className = 'modal-colors';
  p.colors.forEach(function(c, i){
    var btn = document.createElement('button');
    btn.className = 'modal-color-btn' + (i === 0 ? ' active' : '');
    btn.textContent = c;
    btn.addEventListener('click', function(){
      document.querySelectorAll('.modal-color-btn').forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      if (imgs[i]) {
        var mImg = document.getElementById('modal-main-img');
        if (mImg) mImg.src = imgs[i];
      }
    });
    colorDiv.appendChild(btn);
  });

  var featHtml = p.features.map(function(f){ return '<li>' + f + '</li>'; }).join('');

  var infoEl = document.getElementById('modal-info-area');
  infoEl.innerHTML =
    '<div class="modal-stars"><span style="color:#ffd700">★★★★★</span> 4.9 · 250 000+ clients</div>' +
    '<div class="modal-title">' + p.title + '</div>' +
    '<div class="modal-price-row">' +
      '<span class="modal-price-sale">' + p.price + '</span>' +
      '<span class="modal-price-orig">' + p.orig + '</span>' +
      '<span class="modal-price-save">' + p.save + '</span>' +
    '</div>' +
    '<p class="modal-note">⏰ Réduction appliquée automatiquement.</p>' +
    '<div class="modal-clabel">Couleur</div>';
  infoEl.appendChild(colorDiv);
  infoEl.insertAdjacentHTML('beforeend',
    '<button class="modal-add">→ Ajouter au panier — ' + p.price + '</button>' +
    '<div class="modal-trust">' +
      '<div class="modal-trust-item">🚚 Livraison gratuite dès 35 €</div>' +
      '<div class="modal-trust-item">🔄 Retours gratuits 30 jours</div>' +
      '<div class="modal-trust-item">🔒 Paiement 100% sécurisé</div>' +
    '</div>' +
    '<div class="modal-features"><h4>Caractéristiques</h4><ul>' + featHtml + '</ul></div>'
  );

  document.getElementById('modal').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeModal(){
  document.getElementById('modal').classList.remove('open');
  document.body.style.overflow = '';
}
function closeModalOutside(e){ if(e.target===document.getElementById('modal')) closeModal(); }
document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeModal(); });
